module.exports = __webpack_public_path__ + "media/law_firm_funding/hero-e39203e5.jpg";